import { ConnectedAdminsState } from './types';

export const initialState: ConnectedAdminsState = {
  admins: [],
};
